var path = '/app/components/search/search-directalert.component.html';
var html = "<div> <iframe class=\"ifrmDirectAlert\" style=\"width:100%;height:650px\" ng-src=\"{{$ctrl.iframeUrl}}\"></iframe> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;